<template>
  <div class="table-wrap">
    <md-card>
      <md-card-header>
        <md-card-header-text>
          <p class="md-title">Vacaciones</p>
        </md-card-header-text>
        <!-- <md-card-header-text>
          <md-field>
            <md-icon>search</md-icon>
            <label>Burcar</label>
            <md-input v-model="search"></md-input>
          </md-field>
        </md-card-header-text> -->
      </md-card-header>
      <div class="table-card" v-if="tableHeaders.length > 0">
        <div class="table-card__header">
          <div
            class="table-card__header-cell"
            :class="{
              'table-card__header-cell--big': headcell.key === 'employee',
              'table-card__header-cell--biggest': headcell.key === 'dayReport',
            }"
            v-for="headcell in tableHeaders"
            :key="`tablecell-${headcell.key}`"
          >
            <span>
              {{ headcell.label }}
            </span>
          </div>
        </div>
        <div class="table-card__body">
          <div
            class="table-card__body-row"
            :class="{ 'table-card__body-row--alert': row.recomendVacation }"
            v-for="(row, $index) in source"
            :key="`row-${$index}`"
          >
            <div
              class="table-card__body-cell"
              :class="{
                'table-card__body-cell--big': key === 'employee',
                'table-card__body-cell--biggest': key === 'dayReport',
              }"
              v-for="(field, key) in row"
              :key="`row-${$index}-field-${key}`"
              v-show="key !== 'id' && key !== 'recomendVacation'"
            >
              <span>
                {{ field | currency }}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="table-card--empty" v-else>
        <h3>No hay datos</h3>
      </div>
      <!-- {{ getTotal() }} -->
    </md-card>
  </div>
</template>

<script>
// import VGrid from "@revolist/vue-datagrid";
export default {
  props: ["date"],
  name: "ResumeVacation",
  components: {
    // VGrid,
  },
  data() {
    return {
      search: null,
      searched: [],
      aux: null,
      sumatory: {},
      vacationsRequiredArray: [],
    };
  },
  async created() {
    this.$emit("loading", true);
    let res = await this.$store.dispatch("getVacationData", {
      id: this.$store.state.business.businessId,
      startDate: null,
      endDate: this.$route.query.date,
    });
    if (res.status === 200) {
      this.$emit("loading", false);
    }
  },
  computed: {
    summary: {
      get() {
        // console.log("data: ", this.$store.getters.summaryByMonthData);

        this.$store.watch(
          (state, getters) => getters.vacationList,
          (newValue, oldValue) => {
            // console.log({ oldValue });

            // console.log({ newValue });
            this.searched = newValue;
            return this.$store.getters.vacationList;

            // console.log(`Updating from ${oldValue} to ${newValue}`);

            // Do whatever makes sense now
          }
        );
        return this.$store.getters.vacationList;
      },
      set(val) {
        this.$store.commit("SET_SUMMARY_MONTHDATA", val);
      },
    },
    tableHeaders() {
      return [
        {
          key: "employee",
          label: "Empleado",
        },
        {
          key: "day-acumulated-init",
          label: "Días Acumulados al Inicio del mes",
        },
        {
          key: "days-taken",
          label: "Días Tomados en el mes",
        },
        {
          key: "days-gained",
          label: "Días Ganados en el Mes",
        },
        {
          key: "days-acumulated-final",
          label: "Días Acumulados al fin del mes",
        },
        {
          key: "money-acumulated-init",
          label: "Monto Acumulado al inicio del mes",
        },
        {
          key: "money-given",
          label: "Monto entregado del Mes",
        },
        {
          key: "month-provision",
          label: "Monto ganado (Provisión) del Mes",
        },
        {
          key: "money-acumulated-final",
          label: "Monto Acumulado al fin del mes",
        },
        // {
        //   key: "vacation-type",
        //   label: "Tipo de Vacaciones"
        // }
      ];
    },
    source() {
      console.log("source: ", this.$store.getters.vacationList);
      return this.$store.getters.vacationList.map((it) => {
        return {
          id: it.id,
          recomendVacation: it.recommendVacation,
          employee: `${it.firstName} ${it.firstSurname} ${it.secondSurname}`,
          "days-acumulated-init": `${it.totalVacationaccumdaysInitmonth.toFixed(2)}d`,
          "days-taken": `${it.takedMonthVacations}d`,
          "days-gained": `${it.vacationAccumdays.toFixed(2)}d`,
          "days-acumulated-final": `${it.totalVacationaccumdays.toFixed(2)}d`,
          "money-acunulated-init": it.totalVacationaccumpriceInitmonth,
          "money-given": it.takedMonthVacationsprice,
          "month-provision": it.vacationAccumprice,
          "money-acunulated-final": it.totalVacationaccumprice,
          // "vacation-type": 'Vacaciones Truncas',
        };
      });
    },
    dataTable() {
      return [this.tableHeaders, ...this.source];
    },
    searchedComp: {
      get() {
        if (!this.searched.length && !this.search) {
          this.searched = this.summary;
        }
        return this.searched;
      },
      set(val) {
        this.searched = val;
      },
    },
  },
  methods: {
    searchOnTable() {
      if (this.search) {
        console.log(
          this.summary.filter((item) =>
            item.employee.fullName.toLowerCase().includes(this.search.toLowerCase())
          )
        );

        this.searched = this.summary.filter((item) =>
          item.employee.fullName.toLowerCase().includes(this.search.toLowerCase())
        )
          ? this.summary.filter((item) =>
              item.employee.fullName.toLowerCase().includes(this.search.toLowerCase())
            )
          : [];
      } else {
        this.searched = this.summary;
      }
    },
    viewSummary(id) {
      // console.log(id);
      // let item = this.source.find((it) => it.id === id);
      // console.log(item);
      // this.$store.commit("SET_CURRENT_SUMMARY_EMPLOYEE", `${item.employee}`);
      // window.localStorage.setItem("currentSummaryEmployee", `${item.employee}`);
      // this.$router.push({
      //   name: "countingPages",
      //   params: {
      //     id: item.id,
      //     name: `${item.employee}`,
      //     date: new Date(
      //       JSON.parse(window.localStorage.getItem("dateCalc"))
      //     ).toISOString(),
      //   },
      // });
    },
    isNotObject(value) {
      return typeof value !== "object";
    },
  },
  watch: {
    source(n, o) {
      // this.getTotal();
    },
    async $route(n, o) {
      if (n.query && n.query.date) {
        this.$emit("loading", true);
        let res = await this.$store.dispatch("getVacationData", {
          id: this.$store.state.business.businessId,
          startDate: null,
          endDate: this.$route.query.date,
        });
        if (res.status === 200) {
          this.$emit("loading", false);
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.nowrap {
  white-space: nowrap;
}
.fullname {
  min-width: 155px;
}
.cell-report-day {
  min-width: 200px;
  .absence {
    color: #ef476f;
  }
  .assistance {
    color: #2cc0d5;
  }
  .vacation {
    color: #93c737;
  }
  .medical {
    color: #f9de5c;
  }
  .medical-sub {
    color: #d8ff00;
  }
  .extrahours {
    color: #7b1fa2;
  }
  .absence-ex {
    color: #d939cd;
  }
}
.table-wrap {
  // height: calc(100vh - 190px);
  max-height: 500px;
  // overflow-y: scroll;
}
// revo-grid {
//   height: 100%;
// }
// revogr-viewport .main-viewport {
//   height: 100%;
// }
.table-card {
  width: 100%;
  height: 100%;
  max-height: 490px;
  position: relative;
  overflow: auto;
  &__header {
    background-color: #ffffff;
    position: sticky;
    top: 0;
    // width: 100%;
    z-index: 20;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 1340px;
    box-shadow: 0px 3px 5px 0px rgba($color: #999999, $alpha: 0.7);
    &-cell {
      background-color: #ffffff;
      padding: 1rem 0.5rem;
      margin: 0 5px;
      font-weight: bold;
      font-size: 12px;
      flex: 0 0 125px;
      height: 90.59px;
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: right;
      &--big {
        min-width: 250px;
        text-align: left;
        position: sticky;
        justify-content: flex-start;
        left: 0;
        z-index: 10;
        box-shadow: 1px 0px 1px 0px rgba($color: #999999, $alpha: 0.4);
      }
      &--biggest {
        min-width: 800px;
        background-color: rgba($color: #2cc0d5, $alpha: 0.4);
      }
      &__inner {
        width: 100%;
        &--superior {
          width: 100%;
          p {
            text-align: center;
          }
        }
        &--inferior {
          display: flex;
          flex-flow: row nowrap;
          justify-content: flex-start;
          align-items: center;
          &__content {
            min-width: 97px;
            max-width: 97px;
            font-size: 12px;
            padding: 0 0.5rem;
          }
        }
      }
    }
  }
  &__body {
    // padding: 1rem;
    width: fit-content;
    &-row {
      position: relative;
      width: 1340px;
      display: flex;
      justify-content: flex-start;
      align-items: stretch;
      border-bottom: thin solid rgba($color: #999999, $alpha: 0.4);
      &--alert {
        background-color: rgba($color: #97c2c9, $alpha: 0.7);
        & .table-card__body-cell {
          background-color: rgba($color: #97c2c9, $alpha: 0.7);
        }
      }
    }
    &-cell {
      background-color: #ffffff;
      padding: 1rem 0.5rem;
      margin: 0 5px;
      font-weight: normal;
      font-size: 14px;
      flex: 0 0 125px;
      text-align: right;
      &--big {
        position: sticky;
        left: 0;
        text-align: left;
        z-index: 10;
        min-width: 250px;
        box-shadow: 1px 0px 1px 0px rgba($color: #999999, $alpha: 0.4);
      }
      &--biggest {
        min-width: 800px;
        background-color: rgba($color: #2cc0d5, $alpha: 0.4);
      }
      &__inner {
        width: 100%;
        &--superior {
          width: 100%;
          p {
            text-align: center;
          }
        }
        &--inferior {
          display: flex;
          flex-flow: row nowrap;
          justify-content: flex-start;
          align-items: center;
          &__content {
            width: 97px;
            font-size: 12px;
            padding: 0 0.5rem;
            text-align: center;
          }
        }
      }
    }
  }
  &--empty {
    padding: 5rem;
    h3 {
      text-align: center;
    }
  }
}
</style>
